<div
  *ngIf='cService.pageHeader.pageUiSettings?.hasTitleHeader'
  [matTooltip]="cService.isOnline ? '' : 'Check internet connection'"
>
  <div
    [class.red-bg]='!cService.isOnline'
    class='vrm-toolbar main-headers'
    style='color: white'
    [style.background-color]="'#' + cService.userProfile?.HqColour"
  >
    <div class='stretch page-header-content' [class.less-than-md]='!cService.isPcViewport' fxLayout='row'>
      <!-- Page Title -->
      <div
        style='text-align: left; position: relative; bottom: 7px'
        [fxFlex]="cService.isMobileViewport ? '' : '30'"
        [class.hidden]='cService.isMobileViewport && rptService.gridSearch.activated'
      >
        <div fxLayout='row'>
          <ng-content></ng-content>
          <tooltip-badge
            class='information-badge'
            *ngIf='
							cService.selectedNav &&
							cService.selectedNav.pageTip &&
							cService.selectedNav.pageTip.variants
						'
            [tooltipTitle]='
							cService.selectedNav.pageTip.variants[cService.selectedLanguage.code]
								? cService.selectedNav.pageTip.variants[cService.selectedLanguage.code].subject
								: cService.selectedNav.pageTip.subject
						'
            [tooltipMessage]='
							cService.selectedNav.pageTip.variants[cService.selectedLanguage.code]
								? cService.selectedNav.pageTip.variants[cService.selectedLanguage.code].message
								: cService.selectedNav.pageTip.message
						'
          ></tooltip-badge>
        </div>
        <span *ngIf='!cService.isOnline'>&nbsp; {{ 'GENERIC.offline' | translate | uppercase }}</span>
      </div>

      <div fxFlex fxLayout='row' fxLayoutAlign='center' style='z-index: 1' style='padding-right: 25px'>
        <!-- Search -->
        <input
          #pageHeaderSearchInput
          type='text'
          [style.border-color]='searchBorderColor'
          class='header-search'
          [class.rtl]='cService.selectedLanguage.isRtl'
          [placeholder]="'GENERIC.search' | translate"
          *ngIf='!cService.isMobileViewport && cService.pageHeader.canSearch'
          fxFlex
          [(ngModel)]='rptService.gridSearch.text'
          (input)='searchInputChanged()'
          (focus)='searchInputChanged()'
        />

        <div fxLayout='row' *ngIf='cService.pageHeader.canSearch && !cService.isMobileViewport'>
          <button
            mat-icon-button
            (click)='toggleSearchActivation()'
            class='header-search-button'
            [class.rtl]='cService.selectedLanguage.isRtl'
            [style.border-color]='searchBorderColor'
          >
            <mat-icon
              color='primary'
              style='position: relative; bottom: 4px'
              [style.color]="rptService.gridSearch.text || rptService.gridSearch.activated ? 'red' : ''"
            >
              {{ rptService.gridSearch.text || rptService.gridSearch.activated ? 'close' : 'search' }}
            </mat-icon>
          </button>
        </div>

        <!-- Search: mobile version -->
        <div *ngIf='cService.isMobileViewport && cService.pageHeader.canSearch' fxFlex fxLayoutAlign='end'>
          <input
            *ngIf='rptService.gridSearch.activated'
            #pageHeaderSearchInput
            type='text'
            [style.border-color]='searchBorderColor'
            class='header-search'
            [placeholder]="'GENERIC.search' | translate"
            fxFlex
            [(ngModel)]='rptService.gridSearch.text'
            (input)='searchInputChanged()'
            (focus)='searchInputChanged()'
          />

          <button
            mat-icon-button
            *ngIf='cService.isMobileViewport'
            (click)='toggleSearchActivation()'
            [class.header-search-button]='rptService.gridSearch.activated'
            style='height: 36px; color: white'
          >
            <mat-icon
              style='position: relative; bottom: 4px'
              [style.color]="rptService.gridSearch.text || rptService.gridSearch.activated ? 'red' : ''"
            >
              {{ rptService.gridSearch.text || rptService.gridSearch.activated ? 'close' : 'search' }}
            </mat-icon>
          </button>
        </div>
      </div>

      <!-- Right side icons | *ngIf="cService.isMobileViewport && !rptService.gridSearch.activated" -->
      <div
        fxLayout='row'
        [fxFlex]="cService.isMobileViewport ? '10' : '30'"
        fxLayoutAlign='end'
        [class.hidden]='cService.isMobileViewport && rptService.gridSearch.activated'
        style='position: relative; bottom: 5px'
      >
        <!-- Download -->
        <div *ngIf='cService.pageHeader.isReportPage'>
          <button
            mat-button
            (click)="emitDownloadEvent('xlsx')"
            class='sharp-corners'
            style='position: relative; top: 3px'
          >
            <mat-icon style='position: relative; right: 4px; top: 2px' class='padding-l-5 padding-r-5'>
              file_download
            </mat-icon>
            <span *ngIf='!cService.isMobileViewport'>{{ 'REPORTS.downloadReport' | translate }}&nbsp;</span>
          </button>

          <!-- Download with dropdown option for csv / xlsx -->
          <!-- <button mat-button [matMenuTriggerFor]="reportDownloadOptions"
            class="sharp-corners" style="position: relative; top: 3px">
            <mat-icon style="position: relative; right: 4px; top: 2px" class="padding-l-5 padding-r-5">
              file_download
            </mat-icon>
            <span *ngIf="!cService.isMobileViewport">{{ 'REPORTS.downloadReport' | translate }}&nbsp;</span>
            <mat-icon>arrow_drop_down</mat-icon>
          </button>

          <mat-menu #reportDownloadOptions>
            <button type="button" mat-menu-item (click)="emitDownloadEvent('xlsx')"
              [matTooltip]="'REPORTS.downloadReportToExcel' | translate">
              EXCEL (.xlsx)
            </button>

            <button type="button" mat-menu-item (click)="emitDownloadEvent('csv')"
              [matTooltip]="'AGGRIDLOCALE.csvExport' | translate">
              CSV (.csv)
            </button>
          </mat-menu> -->
        </div>

        <!-- Close button: shown only when options are hidden in a readonly window -->
        <button
          *ngIf='!cService.pageHeader.pageUiSettings?.hasMoreOptions'
          mat-stroked-button
          (click)='closeCurrentTab()'
          class='sharp-corners'
          style='position: relative; top: 3px; margin-right: 6px'
        >
          <span *ngIf='!cService.isMobileViewport'>{{ 'GENERIC.close' | translate }}&nbsp;</span>
        </button>
      </div>
    </div>

    <div *ngIf='cService.pageHeader.isDashboard && cService.selectedNav?.isVrmAnalyticsDashboard'>
      <vrm-analytics-chart-filter></vrm-analytics-chart-filter>
    </div>
  </div>

  <mat-divider></mat-divider>
</div>
